import { Component } from '@angular/core';
import { UserJobsService } from './user-jobs.service';
import { ScheduleJobState } from './user-jobs-schedule-state';
import { IUserJob } from '../core/IUserJob';

@Component({
    selector: 'user-jobs',
    templateUrl: 'user-jobs.component.html',
    styleUrls: ['user-jobs.component.scss']
})
export class UserJobsComponent {
  public userJobs: Array<IUserJob>;
  public waitingUserJobs: Array<IUserJob>;
  public executedUserJobs: Array<IUserJob>;
  public isLoadingJobs = true;
  public selectedTab: number = 0;

  constructor(private _userJobService: UserJobsService) { }

  async ngAfterViewInit() {
    await this.getAllData();

  }

  public areThereUserJobs(): boolean {
    return (this.waitingUserJobs && this.waitingUserJobs.length > 0 ) || (this.executedUserJobs && this.executedUserJobs.length > 0 )
  }

  public async getAllData() {
    this.isLoadingJobs = true;
    this.userJobs = await this._userJobService.getAll();
    this.waitingUserJobs = this.userJobs.filter(userjob => userjob && userjob.state === ScheduleJobState[ScheduleJobState.Waiting]);
    this.executedUserJobs = this.userJobs.filter(userjob => userjob && userjob.state === ScheduleJobState[ScheduleJobState.Executed]);
    this.isLoadingJobs = false;
  }
}
